import { RESPONSE_OF_UNPROCESSED_DATA_FOR_NEWS_MODERATION, RESPONSE_POST_PROCESSED_NEWS_DATA_TO_SERVER } from './action';


const newsModerationReducer = (state={}, action) => {
    switch (action.type) {
        case RESPONSE_OF_UNPROCESSED_DATA_FOR_NEWS_MODERATION:
            return state = {
                ...state,
                newsUnprocessedData: action.data.data
            }

        case RESPONSE_POST_PROCESSED_NEWS_DATA_TO_SERVER:
            return state = {
                ...state,
                newsProcessedData: action.data
            }

        default: return state
    }
}
export default newsModerationReducer;